export default __webpack_public_path__ + "static/media/loryGameplay2.2bba6887.png";